
import ArrowBurst from "@/assets/thalo-icons/Arrows Burst.png";
import ArrowsUp from "@/assets/thalo-icons/Arrows Up.png";
import Atom from "@/assets/thalo-icons/Atom.png";
import CircleStar from "@/assets/thalo-icons/Circle Star.png";
import Circles from "@/assets/thalo-icons/Circles.png";
import Clipboard from "@/assets/thalo-icons/Clipboard.png";
import ClockCheck from "@/assets/thalo-icons/Clock Check.png";
import Compass from "@/assets/thalo-icons/Compass.png";
import ConnectedCircles from "@/assets/thalo-icons/Connected Circles.png";
import Cycle from "@/assets/thalo-icons/Cycle.png";
import DataDots from "@/assets/thalo-icons/Data Dots.png";
import DiamondStar from "@/assets/thalo-icons/Diamond Star.png";
import Gauge from "@/assets/thalo-icons/Gauge.png";
import GraphWrench from "@/assets/thalo-icons/Graph Wrench.png";
import Hexagon from "@/assets/thalo-icons/Hexagon.png";
import Infinity from "@/assets/thalo-icons/Infinity.png";
import Intertwined from "@/assets/thalo-icons/Intertwined.png";
import Lightning from "@/assets/thalo-icons/Lightning.png";
import Meridians from "@/assets/thalo-icons/Meridians.png";
import Molecules from "@/assets/thalo-icons/Molecules.png";
import Money from "@/assets/thalo-icons/Money.png";
import PeopleCircle from "@/assets/thalo-icons/People Circle.png";
import People from "@/assets/thalo-icons/People.png";
import PersonPlus from "@/assets/thalo-icons/Person Plus.png";
import PlusPlus from "@/assets/thalo-icons/Plus plus.png";
import Reticule from "@/assets/thalo-icons/Reticule.png";
import Shield from "@/assets/thalo-icons/Shield.png";
import Target from "@/assets/thalo-icons/Target.png";
import Trefoil from "@/assets/thalo-icons/Trefoil.png";
import UpRight from "@/assets/thalo-icons/Up Right.png";
import DownRight from "@/assets/thalo-icons/Down Right.png";

import React from 'react';

const iconMap = {
  "Arrows Burst": ArrowBurst,
  "Arrows up": ArrowsUp,
  "Atom": Atom,
  "Circle Star": CircleStar,
  "Circles": Circles,
  "Clipboard": Clipboard,
  "Clock Check": ClockCheck,
  "Compass": Compass,
  "Connected Circles": ConnectedCircles,
  "Cycle": Cycle,
  "Data Dots": DataDots,
  "Diamond Star": DiamondStar,
  "Gauge": Gauge,
  "Graph Wrench": GraphWrench,
  "Hexagon": Hexagon,
  "Infinity": Infinity,
  "Intertwined": Intertwined,
  "Lightning": Lightning,
  "Meridians": Meridians,
  "Molecules": Molecules,
  "Money": Money,
  "People Circle": PeopleCircle,
  "People": People,
  "Person Plus": PersonPlus,
  "Plus Plus": PlusPlus,
  "Reticule": Reticule,
  "Shield": Shield,
  "Target": Target,
  "Trefoil": Trefoil,
  "Up Right": UpRight,
  "Down Right": DownRight
};


const ThaloIcon = ({
  iconName,
  color = 'bg-white',
  className = '',
  width = 'w-6',
  height = 'h-6',
}: {
  iconName: keyof typeof iconMap;
  color?: string;
  className?: string;
  width?: string;
  height?: string;
}) => {
  const containerClasses = `${color} ${width} ${height} p-1 rounded-lg inline-flex items-center justify-center ${className}`;
  const imgSrc = iconMap[iconName]; // Get the corresponding image source from the iconMap

  return (
    <div className={containerClasses}>
      <img src={imgSrc} alt={iconName} className="max-w-full max-h-full object-contain" />
    </div>
  );
};

export default ThaloIcon;